export default __webpack_public_path__ + "static/media/teaser.c684a7ab.png";